import React from 'react';
import { Box, Flex, Heading, Text, Button, VStack, Circle, Image, useBreakpointValue } from '@chakra-ui/react';
import { FaCode, FaBug, FaPaintBrush } from 'react-icons/fa';
import { MdPhoneIphone } from 'react-icons/md';
import { SiAiqfome } from 'react-icons/si';
import { GiArtificialIntelligence } from 'react-icons/gi';

// 5টি আইকন, 360 ডিগ্রি বৃত্তে সমানভাবে ছড়িয়ে
const iconList = [
  { icon: <FaBug size={24} />, label: 'SQA' },
  { icon: <MdPhoneIphone size={24} />, label: 'Mobile' },
  { icon: <GiArtificialIntelligence size={24} />, label: 'AI' },
  { icon: <FaCode size={24} />, label: 'Development' },
  { icon: <FaPaintBrush size={24} />, label: 'Design' },
];


const SubscribeJobAnnouncement = () => {
  // responsive values
  const iconRadius = useBreakpointValue({ base: 110, md: 170 });
  const iconCenter = useBreakpointValue({ base: 140, md: 250 });
  const iconSize = useBreakpointValue({ base: 36, md: 72 });
  const iconOffset = iconSize / 2; // আইকন সাইজের অর্ধেক
  const boxSize = useBreakpointValue({ base: 260, md: 500 });

  return (
    <Box bg="#235B5E" py={{ base: 8, md: 16, lg: 20 }} px={{ base: 4, md: 0 }}>
      <Flex 
        maxW="7xl" 
        mx="auto" 
        align="center" 
        justify="space-between" 
        direction={{ base: 'column', md: 'row' }}
        gap={{ base: 8, md: 12 }}
      >
        <VStack 
          align={{ base: "center", md: "flex-start" }} 
          spacing={{ base: 4, md: 6, lg: 8 }} 
          flex="1" 
          px={{ base: 4, md: 8 }} 
          textAlign={{ base: "center", md: "left" }}
          maxW={{ base: "100%", md: "50%" }}
        >
          <Heading 
            color="white" 
            fontWeight="bold" 
            fontSize={{ base: 'xl', sm: '2xl', md: '2.5xl', lg: '3.2rem' }} 
            lineHeight="1.1"
            textAlign={{ base: "center", md: "left" }}
          >
            Subscribe For<br />Job Announcement
          </Heading>
          <Text 
            color="white" 
            fontSize={{ base: 'sm', sm: 'md', md: 'lg', lg: 'xl' }} 
            maxW={{ base: "100%", md: "lg" }}
            textAlign={{ base: "center", md: "left" }}
            opacity={0.9}
          >
            Join our job alert list and be the first to know about new opportunities
          </Text>
          <Button
            bg="#E6FF3F"
            color="#215560"
            size={{ base: 'md', md: 'lg' }}
            px={{ base: 6, sm: 8, md: 10, lg: 12 }}
            py={{ base: 4, md: 6, lg: 7 }}
            fontWeight="bold"
            fontSize={{ base: 'md', sm: 'lg', md: 'xl' }}
            borderRadius="full"
            _hover={{ 
              bg: '#D4F02A',
              transform: 'translateY(-2px)'
            }}
            transition="all 0.2s"
          >
            Subscribe
          </Button>
        </VStack>
        <Box 
          flex={{ base: "none", md: "1.2" }} 
          position="relative" 
          minH={{ base: '200px', sm: '260px', md: '400px', lg: '500px' }} 
          minW={{ base: '200px', sm: '260px', md: '400px', lg: '500px' }} 
          display="flex" 
          alignItems="center" 
          justifyContent="center"
          maxW={{ base: "280px", md: "none" }}
          mx="auto"
        >
          <Image 
            src="/png/icon-container.png" 
            alt="icon container" 
            objectFit="contain"
            w={{ base: "200px", sm: "260px", md: "400px", lg: "500px" }}
            h={{ base: "200px", sm: "260px", md: "400px", lg: "500px" }}
            transition="transform 0.3s"
            _hover={{ transform: "scale(1.05)" }}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default SubscribeJobAnnouncement; 